<template>
  <a-modal v-model="visible" :title="$t('数据库配置')" width="60%">
    <div slot="footer">
      <a-button type="default" :loading="loading" @click="visible = false">{{ $t('取消') }}</a-button>
      <a-button type="primary" :loading="loading" @click="handleCommit">{{ $t('保存') }}</a-button>
    </div>
    <a-form-model ref="form" :model="form" :rules="rules" :labelCol="{ span: 3 }" :wrapperCol="{ span: 18 }">
      <a-form-model-item :label="$t('触发类型')" prop="type">
        <a-select v-model="form.type" :options="typeOptions" />
      </a-form-model-item>
      <a-form-model-item :label="$t('触发接口地址')" prop="apiUrl">
        <a-input v-model="form.apiUrl" />
      </a-form-model-item>
      <a-form-model-item :label="$t('模板内容')" prop="content">
        <a-textarea v-model="form.content" />
      </a-form-model-item>
    </a-form-model>
  </a-modal>
</template>
<script>
import { savePageTemplate } from '@/api/app/pageTemplate'

export default {
  data() {
    return {
      visible: false,
      form: {},
      loading: false
    }
  },
  computed: {
    rules() {
      const result = {
        type: [{ required: 'true', message: this.$t('请选择') }],
        apiUrl: [{ required: 'true', message: this.$t('请输入') }],
        content: [{ required: 'true', message: this.$t('请输入') }],
      }
      return result
    },
    typeOptions() {
      return [ { label: this.$t('查询'), value: 'select' }, { label: this.$t('新增'), value: 'insert' }, { label: this.$t('更新'), value: 'update' }, { label: this.$t('删除'), value: 'delete' } ]
    },
  },
  methods: {
    show(data) {
      this.form = { ...data }
      this.visible = true
    },
    handleCommit() {
      this.$refs.form.validate((success, fields) => {
        if (!success) {
          return
        }
        const commitData = {
          ...this.form,
        }
        this.loading = true
        savePageTemplate(commitData).then(res => {
          if (res.code === 0) {
            this.$message.success(this.$t('保存成功'))
            this.$emit('ok', this.form)
            this.visible = false
          } else {
            this.$message.error(res.message || this.$t('保存失败'))
          }
        }).catch(err => {
          this.$message.error(this.$t('保存失败'))
        }).finally(() => {
          this.loading = false
        })
      })
    },
  }
}
</script>